import classNames from 'classnames';
import React, { useContext } from 'react';

import { RicosContext } from './../../ricos-context';

import { EXPAND_BUTTON } from '../data-hooks';
import { ArrowIcon } from '../icons';
import styles from '../statics/styles/collapsible-list-component.rtlignore-scss';

const ExpandCollapseButton: React.FC<{
  onClick: (e: $TSFixMe) => void;
  idx?: string;
  ariaLabel?: string;
  isExpanded?: boolean;
}> = props => {
  const { tabIndex } = useContext(RicosContext);
  const { onClick, ariaLabel } = props;

  return (
    //using 'div' element instead of 'button' to fix a bug of focus on element in Firefox in OSX
    // further reading, https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Clicking_and_focus#Clicking_and_focus
    <div
      role="button"
      tabIndex={-1}
      className={styles.iconContainer}
      onClick={onClick}
      onKeyUp={e => (e.key === ' ' || e.key === 'Enter') && onClick(e)}
      data-hook={EXPAND_BUTTON}
    >
      <ArrowIcon
        role="button"
        tabIndex={tabIndex}
        aria-label={ariaLabel}
        className={classNames(styles.icon, props.isExpanded && styles.isExpanded)}
      />
    </div>
  );
};

export default ExpandCollapseButton;
